import React, { useEffect, useState } from 'react';
import qNav from "@assets/gql/nav.gql";
import { useQuery } from '@apollo/client';
import client from '../../apollo-client';
import { usePopper } from 'react-popper';
import { Link } from '@ambiguous/link';
import { useLang } from '@ambiguous/useLang';
import { LoadingBox } from '@assets/tsx/loadingBox/loadingBox';
export default function Nav({ menu, attach_to, align, prefetch }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const has_prefetch = ((_d = (_c = (_b = (_a = prefetch === null || prefetch === void 0 ? void 0 : prefetch.data) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.menuItems) === null || _c === void 0 ? void 0 : _c.nodes) === null || _d === void 0 ? void 0 : _d.length) > 0;
    const [language] = useLang();
    // if(has_prefetch){
    // 	console.log({prefetch, language})
    // 	client.writeQuery({
    // 		query:qNav,
    // 		data:prefetch.data,
    // 		variables:{
    // 			id:parseInt(menu),
    // 			language:language?.toUpperCase() || 'DEFAULT'
    // 		}
    // 	})	
    // }
    const [parentsArr, childrenObj] = getNavItemGroups((_g = (_f = (_e = prefetch === null || prefetch === void 0 ? void 0 : prefetch.data) === null || _e === void 0 ? void 0 : _e.menu) === null || _f === void 0 ? void 0 : _f.menuItems) === null || _g === void 0 ? void 0 : _g.nodes);
    const [parents, setParents] = useState(parentsArr);
    const [children, setChildren] = useState(childrenObj);
    const { data, loading } = useQuery(qNav, {
        variables: { id: parseInt(menu), language: (language === null || language === void 0 ? void 0 : language.toUpperCase()) || 'DEFAULT' },
        client,
    });
    useEffect(() => {
        var _a, _b;
        if (!data)
            return;
        // if(has_prefetch) return;
        let menu = (_b = (_a = data === null || data === void 0 ? void 0 : data.menu) === null || _a === void 0 ? void 0 : _a.menuItems) === null || _b === void 0 ? void 0 : _b.nodes;
        if (!(menu === null || menu === void 0 ? void 0 : menu.length))
            return;
        const [parentsArr, childrenObj] = getNavItemGroups(menu);
        setParents(parentsArr);
        setChildren(childrenObj);
    }, [data, prefetch]);
    const [list, setList] = useState(null);
    const [offsetParent, setOffsetParent] = useState(null);
    const [wrapRef, setWrapRef] = useState(null);
    const [popperRef, setPopperRef] = useState(null);
    useEffect(() => {
        if (!(wrapRef instanceof HTMLElement))
            return;
        if (attach_to == 'section') {
            const closestSection = wrapRef.closest('section');
            setPopperRef(closestSection);
            return;
        }
        setPopperRef(wrapRef);
    }, [wrapRef]);
    const outsideClick = ({ target }) => {
        const list = target.closest('.ltg-nav-menu');
        if (!list) {
            setList(null);
            document.removeEventListener('click', outsideClick);
        }
    };
    if (loading) {
        const loaderStyle = { display: 'inline-block', width: 70, height: 20, marginRight: 10 };
        return (React.createElement("div", { className: `ltg-nav-menu ltg-nav-align-${align}` },
            React.createElement("div", { className: "ltg-nav-item" },
                React.createElement(LoadingBox, { style: loaderStyle })),
            React.createElement("div", { className: "ltg-nav-item" },
                React.createElement(LoadingBox, { style: loaderStyle })),
            React.createElement("div", { className: "ltg-nav-item" },
                React.createElement(LoadingBox, { style: loaderStyle }))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ltg-nav-menu" + `${attach_to == 'section' ? ' ltg-nav-menu--section' : ''} ltg-nav-align-${align}`, ref: setWrapRef }, parents === null || parents === void 0 ? void 0 :
            parents.map(({ path, label, target, id }) => {
                return (React.createElement(Link, { href: path, className: `ltg-nav-item`, key: id, onClick: (ev) => {
                        if (Object.keys(children).includes(id)) {
                            if (list == children[id]) {
                                setList(null);
                                document.removeEventListener('click', outsideClick);
                                return;
                            }
                            ev.preventDefault();
                            document.addEventListener('click', outsideClick);
                            setList(children[id]);
                            setOffsetParent(ev.target);
                        }
                        else {
                            setList(null);
                        }
                    }, target: target, rel: target == '_blank' ? 'noreferrer noopener' : null }, label));
            }),
            list && React.createElement(List, { offset: offsetParent, items: list, popperRef: popperRef, closeNav: () => { setList(null); } }))));
}
function getNavItemGroups(menu) {
    if (!menu)
        return [[], []];
    return menu.reduce(([parents, children], parent) => {
        var _a;
        const { childItems, id, label, path, target } = parent;
        const parentAgr = [
            ...parents,
            { id, label, path, target }
        ];
        const childrenAgr = Object.assign({}, children);
        if (((_a = childItems === null || childItems === void 0 ? void 0 : childItems.nodes) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            childrenAgr[id] = childItems.nodes;
        }
        return [parentAgr, childrenAgr];
    }, [[], {}]);
}
function List({ items, popperRef, closeNav, offset }) {
    const [popperEl, setPopperEl] = useState(null);
    const [offsetLeft, setOffsetLeft] = useState(() => {
        if (!offset)
            return 0;
        return offset.getBoundingClientRect().left;
    });
    const { styles, attributes } = usePopper(popperRef, popperEl, {
        placement: 'bottom-start'
    });
    useEffect(() => {
        if (!(offset === null || offset === void 0 ? void 0 : offset.getBoundingClientRect))
            return;
        setOffsetLeft(offset.getBoundingClientRect().left);
    }, [offset]);
    function handleResize() {
        setOffsetLeft((offset === null || offset === void 0 ? void 0 : offset.getBoundingClientRect) ? offset.getBoundingClientRect().left : 0);
    }
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [offset]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", Object.assign({ className: `${items ? '' : 'd-none'} ltg-nav-children`, ref: setPopperEl, style: styles.popper }, attributes.popper),
            React.createElement("div", { className: "ltg-nav-children-content", style: { paddingLeft: offsetLeft - 5 } }, BuildItems(items)))));
    function BuildItems(items, deep = 1) {
        const Item = ({ item, hasChildren }) => (React.createElement(Link, { href: item.path, target: item.target, className: `ltg-nav-link${hasChildren ? ' --has-children' : ''}`, onClick: () => {
                closeNav && closeNav();
            } }, item.label));
        // if (deep == 1) {
        // 	return <>
        // 		{items && items.map((item: NavItem) => <ul key={item.id}><Item item={item} /></ul>)}
        // 	</>
        // }
        return (React.createElement("ul", { className: `nav-menu--deep-${deep}` }, items && items.map(item => {
            var _a, _b, _c, _d, _e;
            return (React.createElement("li", { key: item.id },
                React.createElement(Item, { hasChildren: ((_b = (_a = item === null || item === void 0 ? void 0 : item.childItems) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.length) > 0, item: item }),
                ((_d = (_c = item === null || item === void 0 ? void 0 : item.childItems) === null || _c === void 0 ? void 0 : _c.nodes) === null || _d === void 0 ? void 0 : _d.length) > 0 && BuildItems((_e = item.childItems) === null || _e === void 0 ? void 0 : _e.nodes, deep + 1)));
        })));
    }
}
